import type { SupportReceiptType } from './types';
import type { PaymentMethodType } from '@autopass-web/types';

export const ERROR_CODES = {
  NO_ACTIVE_TRANSACTION: 'NO_ACTIVE_TRANSACTION',
  EXPIRED: 'EXPIRED',
  NOT_FOUND: 'NOT_FOUND',
  HAS_PAID: 'HAS_PAID',
  CANCELLED: 'CANCELLED',
  USER_CANCELLED: 'USER_CANCELLED',
  FAIL: 'FAIL',
} as const;

export const PATHS = {
  NOTFOUND: '/notfound',
  INVOICES: (invoiceId: string) => {
    const invoices = `/invoices/${invoiceId}`;
    return {
      '': invoices,
      ERROR: {
        '': `${invoices}/error`,
        USER_CANCELLED: `${invoices}/error/user-cancelled`,
        STORE_CANCELLED: `${invoices}/error/store-cancelled`,
        EXPIRED: `${invoices}/error/expired`,
      },
      SUCCESS: `${invoices}/success`,
      AUTH: {
        '': `${invoices}/auth`,
        CREDIT_CARD: `${invoices}/auth/credit-card`,
        JKOPAY: `${invoices}/auth/jkopay`,
        TAIWAN_PAY: `${invoices}/auth/taiwan-pay`,
      },
    } as const;
  },
};

// the default value of NODE_ENV is 'production'
export const ENV = process.env['NODE_ENV'] as 'production' | 'development';

const SUPPORTED_PAYMENTS: { method: PaymentMethodType; enable: boolean }[] = [
  { method: 'apple_pay', enable: true },
  { method: 'line_pay', enable: true },
  { method: 'easy_wallet', enable: false },
  { method: 'credit_card', enable: true },
  { method: 'jkopay', enable: true },
  { method: 'taiwan_pay', enable: true },
  { method: 'autopass', enable: true },
  { method: 'auto_partner', enable: ENV === 'development' },
];

export const DEFAULT_SUPPORTED_PAYMENTS: PaymentMethodType[] =
  SUPPORTED_PAYMENTS.filter(({ enable }) => enable).map(({ method }) => method);

export const PAYMENT_CARRIER_PAYMENTS = ['auto_partner', 'autopass'];

export const ALLOWED_RECEIPT_TYPES = {
  WITH_EMAIL: ['carrier_member', 'carrier_mobile_barcode', 'b2b', 'donate'],
  WITHOUT_EMAIL: ['carrier_mobile_barcode', 'donate'],
} as Record<string, SupportReceiptType[]>;

export const CHAIN_STORE_DEFAULT_EMAIL = 'chainstore_noreceipt@pklotcorp.com';
